import React from 'react';

import GetCamps from '@src/api/GetCamps';
import { generateBusiness } from '@src/factories';
import useAxiosRequestConfig from '@src/hooks/useAxiosRequestConfig';
import useFlatList from '@src/hooks/useFlatList';
import { Business } from '@src/types';

const useCamps = () => {
  const axiosRequestConfig = useAxiosRequestConfig();

  const makeRequest = React.useCallback(
    async (offset: number, limit: number): Promise<Business[]> => {
      const response = await GetCamps(offset, limit, axiosRequestConfig);
      return response.data.businesses.map((business) =>
        generateBusiness(business)
      );
    },
    [axiosRequestConfig]
  );

  return useFlatList(makeRequest);
};

export default useCamps;
